<template>
    <div class="recent-fundings-outer" v-show="donators.length > 0">
        <h5 class="title-5">Recent Fundings</h5>
        <ul v-show="donators.length" v-for="donator in showingDonators" v-bind:key="donator.id" class="donator">
            <li>
                <div class="funding-img">
                    <!--<img src="/images/content/donor-image.jpg">-->
                    <img :src="donator.avatar_url">
                </div>
                <div class="funding-details">
                    <h6 class="title-6">{{numberToCurrency(donator.amount)}}</h6>
                    <span>{{donator.name}}</span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: { 
        fundraiserId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            donators: [],
            route: null,
            showing: 7
        }
    },
    computed: {
        showingDonators(){
            return this.donators.slice(0, this.showing);
        }
    },
    mounted() {

        window.kinfEvents.$on('FundingDonators:sendRoutes', (routes) => {
            this.route = routes.fundraiser_recent_donors.replace('FID', this.fundraiserId); 
            window.axios.get(this.route)
                        .then((response) => {
                            this.donators = response.data.data;
                        });            
        });
    },
    methods:{
        numberToCurrency(number){
            let formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
                // the default value for minimumFractionDigits depends on the currency
                // and is usually already 2
            });

            return formatter.format(number).replace('$','$ ');
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/js/views/fundraisers/components/show/FundingDonators.vue